export type SocialPlatform =
  | "instagram"
  | "facebook"
  | "threads"
  | "bluesky"
  | "mastodon";

export interface PlatformConfig {
  label: string;
  className: string;
  endpoint: string;
  icon?: string;
}

export interface PlatformLinkConfig {
  getUrl: (livePostId: string) => string;
  label: string;
}

export const PLATFORM_CONFIG: Record<SocialPlatform, PlatformConfig> = {
  threads: {
    label: "Post to Threads",
    className: "btn bg-gray-950 hover:bg-gray-900 text-white",
    endpoint: "/threads/posts/publish",
  },
  instagram: {
    label: "Post to Instagram",
    className: "btn text-white bg-pink-500 hover:bg-pink-800",
    endpoint: "/instagram/publish",
  },
  facebook: {
    label: "Post to Facebook",
    className: "btn text-white bg-blue-700 hover:bg-blue-900",
    endpoint: "/facebook/publish",
  },
  bluesky: {
    label: "Post to Bluesky",
    className: "btn bg-blue-500 hover:bg-blue-800 text-white",
    endpoint: "/bluesky/publish",
  },
  mastodon: {
    label: "Post to Mastodon",
    className: "btn bg-violet-600 hover:bg-violet-400 text-white",
    endpoint: "/mastodon/publish",
  },
};

export const PLATFORM_LINK_CONFIG: Record<string, PlatformLinkConfig> = {
  instagram_api: {
    getUrl: (livePostId: string) => livePostId,
    label: "View Instagram Post",
  },
  facebook_api: {
    getUrl: (livePostId: string) => `https://facebook.com/${livePostId}`,
    label: "View Facebook Post",
  },
  bluesky_api: {
    getUrl: (livePostId: string) => livePostId,
    label: "View BlueSky Post",
  },
  mastodon_api: {
    getUrl: (livePostId: string) => livePostId,
    label: "View Mastodon Post",
  },
};

export const PLATFORM_SLUGS = {
  THREADS: "threads_api",
  INSTAGRAM: "instagram_api",
  FACEBOOK: "facebook_api",
  BLUESKY: "bluesky_api",
  MASTODON: "mastodon_api",
} as const;
